import { useCallback } from 'react';

import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { PaginatedLocationList, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseAutoCompleteLocations {
  search?: string;
}

function useAutoCompleteLocations({
  search,
}: IUseAutoCompleteLocations): UseQueryResult<AxiosResponse<PaginatedLocationList>> {
  const fetchAutoCompleteLocations = useCallback((): Promise<AxiosResponse<PaginatedLocationList>> => {
    const params: UrlParams = { limit: '100', offset: '0' };

    if (search) {
      params.search = search;
    }

    return client.get(`locations/auto_complete/?${encodeUrlParams(params)}`);
  }, [search]);

  return useQuery(['locations-autocomplete', search], fetchAutoCompleteLocations);
}

export default useAutoCompleteLocations;
